import { Link } from 'react-router-dom';
import { useAccount } from '../lib/accountApi.ts';

/**
 * The global chrome: who you are, the way back to your events, and the way out.
 * It rides on every route except the slideshow - a TV in a room full of guests
 * has no business carrying a host's email or a Sign out button.
 *
 * It asks the shared account store itself rather than taking props, so it works
 * the same on pages that care about an account and pages that do not.
 */
export default function AccountBar() {
  const { account, signOut } = useAccount();

  // `null` means the answer is still in flight. Rendering signed-out links and
  // then swapping them for an email is a worse flicker than a moment of nothing
  // - but the nothing has to be exactly the right height, or the page below
  // jumps when the answer lands.
  const pending = account === null;

  return (
    <nav
      className="flex shrink-0 items-center justify-end gap-2 px-6 py-3 text-sm"
      aria-hidden={pending}
      aria-label="Account"
    >
      <div className={`flex items-center gap-2 ${pending ? 'invisible' : ''}`}>
        {account ? (
          <>
            <span className="mr-1 hidden text-muted sm:inline">{account.email}</span>
            <Link to="/dashboard" className="btn btn-ghost">
              Your events
            </Link>
            <button type="button" className="btn btn-ghost" onClick={signOut}>
              Sign out
            </button>
          </>
        ) : (
          <>
            <Link to="/signin" className="btn btn-ghost">
              Sign in
            </Link>
            <Link to="/signup" className="btn btn-ghost">
              Create account
            </Link>
          </>
        )}
      </div>
    </nav>
  );
}
